import { highlightElement } from './highlightElement';

// Scroll element into view. Padding is space above the element
export function scrollIntoView(
  element: HTMLElement,
  {
    // TODO: remove these properties - we're using scrollIntoView() now
    // padding,
    noTransition,
    // container,
    highlight,
  }: {
    padding?: number;
    noTransition?: boolean;
    container?: string;
    highlight?: boolean;
  } = {},
) {
  element.scrollIntoView({ behavior: noTransition ? 'instant' : 'auto' });

  if (highlight) highlightElement(element);
}
